import * as React from "react"
import { connect } from "react-redux"

import { Symbols } from "@tenforce/toolbox-fontmap"
import env from "../../../../../env"
import { ActionAnchor, ActionType } from "@tenforce/toolbox-button-push-react"
import { GlobalState } from "../../../../../store"
import { IPendingNotifications } from "../index"

const applicationPath = env.applicationPath
const notificationsUrl = `${applicationPath}/dashboard/pending`

interface OwnProps {
    label: string
}

interface StateProps extends IPendingNotifications {
    showDashboard: boolean
}

type Props = OwnProps & StateProps

export const PendingNotificationsButton = ({
    label,
    unreadNotificationsCounter,
    showDashboard,
}: Props): JSX.Element => (
    <>
        {showDashboard && (
            <ActionAnchor
                href={notificationsUrl}
                title={label}
                actionType={ActionType.icon}
                id="pendingNotificationsButton"
                extraClasses="is-inverted no-underline"
            >
                {Symbols.Notifications}
                {unreadNotificationsCounter > 0 && (
                    <sup
                        className="text-cadmium-red animate-poppulse"
                        id="unreadNotificationsIndicator"
                    >
                        {Symbols.Bullet}
                    </sup>
                )}
            </ActionAnchor>
        )}
    </>
)

const mapStateToProps = (state: GlobalState): StateProps => ({
    ...state.pendingNotifications,
    showDashboard: state.userInfo.showDashboard,
})

export default connect(mapStateToProps, {})(PendingNotificationsButton)
